// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
//const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

//////////////////////////////////////
/// OPTIONS FOR DRILLDOWN MENU
///////////////////////////////////

var options = {
    event: "click", // * View note below
    selector: "a", // * View note below
    speed: 100,
    cssClass: {
        container: "drilldown-container",
        root: "drilldown-root",
        sub: "drilldown-sub",
        back: "drilldown-back",
    },
};



// #########################################################################################################
// Show/Hide Menu
// #########################################################################################################


// $('#hamburger_container').click(function(){
// if($(this,'.hamburger').hasClass('open')){
// $(this,'.hamburger').removeClass('open');
// //$('#nav').eq(0).fadeOut(500);
// $('#header-drilldown').slideUp(250);
// }
// else{
// $(this,'.hamburger').addClass('open');
// //$('#nav').eq(0).fadeIn(500);
// $('#header-drilldown').slideDown(250);
// }
// });



/////////////////////////////////////////////////
/// INSTANTIATE ALL THE THINGS ON DOCUMENT.READY
///////////////////////////////////////////////

jQuery(function ($) {
  // ExampleComponent1.init();
  // ExampleModule2.init();
  // ReplaceObfuscatedEmailAddresses.init();
  // AnimateOnPageLinks.init();
  $(".nav-trigger").on("click", function (e) {
	$("body").toggleClass("nav-active"); //you can list several class names
	e.preventDefault();
  });

  // $(".search-trigger").on("click", function (e) {
	// $("body").toggleClass("search-active"); //you can list several class names
	// e.preventDefault();
  // });



    $(".drilldown").drilldown(options);
  
});

